import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const genericTemplateHtml =
'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.generic_template_html_label_reply_img_url + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.generic_template_html_placeholder_reply_img_url + '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
'<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
  '<div class="dz-default dz-message">' +
    '<input type="file" class="d-none" name="uploaded-file-file" id="uploaded-file-file">' +
    '<i class="fas fa-cloud-upload-alt"></i>' +
  '</div>' +
'</div>' +
'<span class="text-small text-muted">' + lang.generic_template_html_info_supported_media + '</span>' +
'</div>' +

'<div class="form-group text-left mt-2">' + 
'<label for="generic-template-image-link">' + lang.generic_template_html_label_dest_img_link + '</label>' +
'<input type="text" class="form-control" id="generic-template-image-link" aria-describedby="generic-template-image-link-help">' +
'</div>' +

'<div class="form-group text-left mt-2">' + 
'<label for="generic-template-title">' + lang.generic_template_html_label_title + '</label>' +
'<input type="text" class="form-control" id="generic-template-title" aria-describedby="generic-template-title-help">' +
'</div>' +

'<div class="form-group text-left mt-2">' + 
'<label for="generic-template-subtitle">' + lang.generic_template_html_label_subtitle + '</label>' +
'<input type="text" class="form-control" id="generic-template-subtitle" aria-describedby="generic-template-subtitle-help">' +
'</div>' +

// Adds html for delay system
delayHtml